import { Table } from "../../../features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C5Issuer, issuers_columns } from "./columns";
import { type FilterC5IssuersSchema, FilterC5Issuers } from "./filter";
import { useTranslation } from "react-i18next";

export const C5IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<C5Issuer, FilterC5IssuersSchema>
      label={t(`${Tables.C5_ISSUERS}.title`, { defaultValue: "Issuers" })}
      client={Clients.C5}
      table_name={Tables.C5_ISSUERS}
      columns={issuers_columns}
      filter={<FilterC5Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C5}/${Tables.C5_ISSUERS}/new`,
        },
      ]}
    />
  );
};
